var sectionBackgroundPropsSet = new Set(['base.background', 'base.background.strong']);

export { sectionBackgroundPropsSet };
//# sourceMappingURL=PageSectionContainer.type.js.map
